// Marks the inputs that hold a typed bank credential (routing and account numbers), so every
// recorder that serialises the DOM — Sentry replay, the terms-agreement snapshot — blocks the same
// fields in both portals. client-v2 deep-imports this module, so it must stay import-free.
const BANK_CREDENTIAL_ATTRIBUTE = 'data-bank-credential';

export const BANK_CREDENTIAL_PRIVACY = Object.freeze({
  selector: `[${BANK_CREDENTIAL_ATTRIBUTE}]`,
  domProps: Object.freeze({ [BANK_CREDENTIAL_ATTRIBUTE]: true }),
});
